/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { BEM } from "@adapptio/lib-components";
import { Panel, PANEL_STYLE } from "../../../../../../ui/components/Panel";
import { CodeEditor } from "@adapptio/lib-editor-ui";
import { ISchemaConstStringModel } from "@adapptio/lib-blueprint";
import { useBlueprintModel } from "../../../../../../ui/hooks";

export interface IThemeEditorMainBlockProps {
	className?: string;
	contentModel: ISchemaConstStringModel;
}

export const ThemeEditorMainBlock: React.FC<IThemeEditorMainBlockProps> = ({ className, contentModel }) => {
	const baseClass = BEM("edt-theme-editor-main-block");

	const { model } = useBlueprintModel(contentModel, "constString");

	const handleChange = useCallback(
		(value: string) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (className) {
		baseClass.add(className);
	}

	return (
		<Panel style={PANEL_STYLE.NONE} scroll={false} className={baseClass.toClassName()}>
			<CodeEditor language="css" value={model.value} onChange={handleChange} />
		</Panel>
	);
};
